const getImageUrl = (imagePath) => {
  const cloudFrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;
  // Remove leading slash if present
  const cleanPath = imagePath.replace(/^\//, '');
  return `${cloudFrontUrl}/${cleanPath}`;
};

export default getImageUrl; 